import React, { createContext, useContext } from "react";
export var GlobalContext = createContext({
    vendor: "asurion",
    article: {
        articleId: "",
        articleTitle: "",
        source: "global",
    },
});
export var GlobalProvider = function (_a) {
    var children = _a.children, vendor = _a.vendor, article = _a.article;
    var values = {
        vendor: vendor,
        article: article,
    };
    return (React.createElement(GlobalContext.Provider, { value: values }, children));
};
export var useGlobalContext = function () {
    return useContext(GlobalContext);
};
